import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSB = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M42.678 42.678c9.376-9.376 9.747-24.345 1.115-34.165L25 25 8.513 43.793c9.82 8.632 24.79 8.261 34.165-1.115Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M7.323 7.322c9.376-9.376 24.345-9.747 34.165-1.115L25.001 25 6.208 41.487c-8.631-9.82-8.261-24.79 1.115-34.165Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m41.488 6.207-35.28 35.28c.357.405.727.803 1.115 1.19.387.388.785.759 1.191 1.115l35.28-35.28a25.282 25.282 0 0 0-1.115-1.19 25.37 25.37 0 0 0-1.191-1.115Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m10.533 8.695.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.027h1.746l.54-1.66ZM19.453 8.695l.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.027h1.746l.54-1.66ZM10.533 17.39l.54 1.662h1.746l-1.413 1.026.54 1.66-1.413-1.026L9.12 21.74l.54-1.661-1.413-1.026h1.746l.54-1.661ZM19.453 17.39l.54 1.662h1.746l-1.413 1.026.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.026h1.746l.54-1.661ZM14.993 13.043l.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.027h1.746l.54-1.66Z"
}));
FlagSB.displayName = 'FlagSB';
export default withFlagWrapper(FlagSB);
//# sourceMappingURL=index.js.map